<template>
  <v-card>
    <v-form @submit.prevent="submitAddClient()" ref="addClientForm">
      <v-card-title>
        <span class="headline">Add Client</span>
      </v-card-title>
      <v-container grid-list-lg>
        <v-layout wrap>
          <v-flex xs12 sm6>
            <v-text-field
              label="* Name"
              v-model="client.name"
              :rules="nameRules"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="* ABN"
              v-model="client.abn"
              :rules="abnRules"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Contact Email"
              v-model="client.contactEmail"
              :rules="contactEmailRules"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Contact Phone"
              v-model="client.contactPhone"
              :rules="contactPhoneRules"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="primaryGrey" flat @click="close()">Cancel</v-btn>
        <v-btn :color="primaryNeutral" flat type="submit" :loading="addingClient">Add</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import ClientService from "@/services/requests/clientService";
import ClientValidation from "@/services/validation/clientValidation";
export default {
  mixins: [ClientValidation],
  data() {
    return {
      client: {
        name: "",
        abn: "",
        contactEmail: "",
        contactPhone: "",
        contractorId: ""
      },
      contractors: [],
      addingClient: false,
      loadingContractors: false
    };
  },
  methods: {
    submitAddClient() {
      if (!this.$refs.addClientForm.validate()) {
        this.snack({ color: "red", text: "Please correct your form errors" });
        return;
      }
      this.addClient();
    },
    addClient() {
      this.loading = true;

      ClientService.addClient(this.client)
        .then(result => {
          this.loading = false;
          //console.log(result);
          this.$store.commit("clients/addToArrayState", {
            prop: "clients",
            value: result.data.result
          });
          this.resetForm();
          this.snack({ color: "green", text: "Client was added" });
          this.close();
        })
        .catch(err => {
          this.snackError();
          this.addingClient = false;
          console.log(err);
        });
    },
    resetForm() {
      this.client.name = "";
      this.client.contactEmail = "";
      this.client.contactPhone = "";
      this.client.contractor = "";
      this.$refs.addClientForm.resetValidation();
    },
    close() {
      this.$emit("close");
    }
  },
  mounted() {}
};
</script>

<style>
</style>
